export default __webpack_public_path__ + "static/media/delete-24px.50b853e1.svg";